import React, {Component} from 'react';
import {Label, UncontrolledTooltip} from "reactstrap";
import './Announcement.css';
import {DatePicker, Form, Switch} from "antd";
import {deepCopyObject, showAxiosError, trimObject, uploadImagesAndReplaceInHtml} from "../../util/Helpers";
import {validateComponent, validateField} from "../../common/validation";
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import moment from "moment";
import Select from 'react-select';
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";

class AnnouncementForm extends Component {

	constructor(props) {
		super(props);
		console.log(this.props);

		this.state = {
			error: {},
			mode: 'create',
			key: Math.random().toString(36),
			page: 0,
			size: 10,
			manual: false,
			loading: false,
			selectedGroups:[],
			selectedGroupsBackup:null,
			userGroups:this.props.userGroups,
			isLoading: false,
			announcement: {
				title:null,
				text: null,
				startDate: null,
				endDate: null,
				announcementAttachments:[],
				announcementGroups: [],
				selectedGroups:[],
				ilanYeri: true,
				ilanTuru: null,
				postId:null,
			},
			editorState : null//BraftEditor.createEditorState(null )
		};

		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.saveAnnouncement = this.saveAnnouncement.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.onChangeEditor=this.onChangeEditor.bind(this);
		this.mapAttachedGroupstoSelectElements=this.mapAttachedGroupstoSelectElements.bind(this);
		this.validateAnnouncementInfo=this.validateAnnouncementInfo.bind(this);
		this.onEditorStateChange=this.onEditorStateChange.bind(this);
		this.handleEditorChange=this.handleEditorChange.bind(this);
		this.transformHtml=this.transformHtml.bind(this);
	}

	onEditorStateChange(editorState) {
		console.log(editorState);
		this.setState({
			editorState,
		});
	};

	async componentDidMount() {
		if (this.props.selectedAnnouncement) {

			let selectedAnnouncement = deepCopyObject(this.props.selectedAnnouncement);
			const currGroups=this.mapAttachedGroupstoSelectElements();
			console.log("currGroups",currGroups);
			const  htmlContent  =  this.props.selectedAnnouncement ? this.props.selectedAnnouncement.text: "";
			selectedAnnouncement.startDate =
				selectedAnnouncement.startDate
					? moment.utc(selectedAnnouncement.startDate).startOf("day")
					: null;

			selectedAnnouncement.endDate =
				selectedAnnouncement.endDate
					? moment.utc(selectedAnnouncement.endDate).startOf("day")
					: null;
			this.setState({
				mode: this.props.mode,
				announcement: selectedAnnouncement,
				selectedGroups: currGroups,
				editorState : BraftEditor.createEditorState(htmlContent),
			});

		}
	}

	mapAttachedGroupstoSelectElements(){
		const currGroups=[];
		const attachedGroups=deepCopyObject(this.props.selectedAnnouncement.announcementGroups);
		const allUserGroups=this.props.userGroups;
		for (const attachedGroup of attachedGroups)
		{
			for(const group of allUserGroups) {
				if (attachedGroup.groupId===group.value) {
					currGroups.push(group);
				}
			}
		}
		return currGroups;
	}

	validateAnnouncementInfo(){
		let announcementInfo=this.state.announcement;
		let selectedGroups=this.state.selectedGroups;
		let errorMessage='';
		if(announcementInfo.title===null || announcementInfo.title.toString().trim()==='')
		{
			errorMessage += 'Başlık Boş Olamaz!</br>'  ;
		}
		if(announcementInfo.text===null || announcementInfo.text.toString().trim()==='')
		{
			errorMessage += 'Duyuru Metni Boş Olamaz!</br>'  ;
		}
		if(announcementInfo.startDate===null || announcementInfo.startDate.toString().trim()==='')
		{
			errorMessage += 'Başlangıç Tarihi Seçiniz!</br>'  ;
		}
		if ((!selectedGroups || selectedGroups.length === 0) && !announcementInfo.ilanYeri)
		{
			errorMessage += 'En Az Bir Duyuru Grubu Seçiniz!</br>'  ;
		}
		if (announcementInfo.ilanYeri && (announcementInfo.ilanTuru===null || announcementInfo.ilanTuru.toString().trim()==='')){
			errorMessage += 'İlan/Haber Türü Seçiniz!</br>';
		}
		return errorMessage;
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
		let result = validateField(rule, boundary, value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangeAnnouncement(e) {
		this.setState({
			announcement: {
				...this.state.announcement,
				[e.target.name]: e.target.value
			}
		})
	}

	onChangeEditor( event, editor ) {
		let announcementInfo=this.state.announcement;
		announcementInfo['text']=editor.getData().trim();
		this.setState({announcementInfo });
	}

	transformHtml = (html) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");

		doc.querySelectorAll("div.media-wrap.image-wrap").forEach((div) => {
			const classes = div.getAttribute("class") && div.getAttribute("class").split(/\s+/) || [];

			// media-wrap ve image-wrap her zaman kalacak
			const newClasses = ["media-wrap", "image-wrap"];
			let alignClass = "";

			// hizalama class'ını normalize et
			if (classes.includes("align-right")) {
				alignClass = "alignright";
			} else if (classes.includes("align-left")) {
				alignClass = "alignleft";
			} else if (classes.includes("align-center")) {
				alignClass = "aligncenter";
			}

			if (alignClass) {
				newClasses.push(alignClass);
			}

			// div class'ını güncelle
			div.setAttribute("class", newClasses.join(" "));

			// içindeki img'lere de aynı alignClass ekle
			div.querySelectorAll("img").forEach((img) => {
				const imgClasses = ["media-wrap", "image-wrap"];
				if (alignClass) {
					imgClasses.push(alignClass);
				}
				img.setAttribute("class", imgClasses.join(" "));
			});
		});

		const innerHtml = doc.body.innerHTML;

		// Dış kapsayıcı ile sarmala
		return `<div style="padding-bottom: 100px; margin: auto; width: 90%; display: flex; justify-content: center; flex-direction: column;">${innerHtml}</div>`;
	};


	handleEditorChange  =  (editorState) => {
		this.setState ( { editorState} )
		let announcementInfo=this.state.announcement;
		const html = editorState.toHTML();
		announcementInfo['text']=html;
		this.setState({ announcementInfo });
	}

	onChangeDate(name,value) {
		let announcementInfo=this.state.announcement;
		announcementInfo[name]=value;
		this.setState({ announcementInfo });
		// console.log(announcementInfo);
	}
	onChangeIlanTuru(name,value) {
		let announcementInfo=this.state.announcement;
		announcementInfo[name]=value.value;
		this.setState({ announcementInfo });
	}

	onChangeIlanYeri(name,value) {
		let announcementInfo=this.state.announcement;
		let selectedGroups=this.state.selectedGroups;
		let selectedGroupsBackup=this.state.selectedGroupsBackup;
		announcementInfo[name]=value;
		if(value){
			selectedGroupsBackup = this.state.selectedGroups;
			selectedGroups=[];
		} else {
			selectedGroups=selectedGroupsBackup;
		}
		this.setState({ announcementInfo, selectedGroups, selectedGroupsBackup });
	}

	onSelectInfoChange(e){
		let selectedGroups=this.state.selectedGroups;
		console.log("e",e);
		console.log("selectedGroups",selectedGroups);
		if(e===null) {
			selectedGroups=[];
		}
		else {
			selectedGroups=[];
			selectedGroups=e.slice();
		}
		this.setState({selectedGroups });
	}

	async saveAnnouncement() {
		let self = this;
		let params;
		let data;
		let message;
		let validity = this.validateAnnouncementInfo();
		if (validity ==='') {
			self.setState({isLoading:true});
			let announcement = deepCopyObject(this.state.announcement);
			announcement.selectedGroups=deepCopyObject(this.state.selectedGroups);
			announcement=trimObject(announcement);
			announcement.text = await uploadImagesAndReplaceInHtml(announcement.text);
			data = announcement;
			if (announcement.id === null) {
				message = 'Duyuru Başarıyla Kaydedildi.'
				params = {
					url: API_BASE_URL + "/announcement",
					data: data,
					method: 'post'
				};
			} else {
				message = 'Duyuru Başarıyla Güncellendi.'
				params = {
					url: API_BASE_URL + "/announcement",
					data: data,
					method: 'patch'
				};
			}
			request(params).then(() => {
				Alert.success(
					message, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				self.setState({isLoading:false});
				this.cancelProcess();
			}).catch(function (error) {
				self.setState({isLoading:false});
				showAxiosError(error);
			});
		}
		else{
			Alert.error(
				validity, {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 8000
				});
		}
	}


	/*	clearForm() {
            this.setState({
                key: Math.random().toString(36),
                selectedRole: null,
                user: {
                    firstName: null,
                    lastName: null,
                    username: null,
                    email: null,
                    roleId: null,
                    branchList: []
                }
            })
        }*/

	cancelProcess() {
		this.props.cancelProcess();
	}


	render() {
		let tStartDate = this.state.announcement.startDate ? {value: this.state.announcement.startDate} : {};
		let tEndDate = this.state.announcement.endDate ? {value: this.state.announcement.endDate} : {};

		const IlanTuruOptions=[
			{ label: 'Nöbet Listesi', value: 'NOBET_LISTESI' },
			{ label: 'Oda İlan', value: 'ODA_ILAN' },
			{ label: 'TEB', value: 'TEB_ILAN' },
			{ label: 'Başkan İlan', value: 'BSK_ILAN' },
			{ label: 'Genel İlan', value: 'GNL_ILAN' },
			{ label: 'IDU İlan', value: 'IDU_ILAN' },
			{ label: 'IGC İlan', value: 'IGC_ILAN' },
			// { label: 'KANS İlan', value: 'KANS_ILAN' },
			{ label: 'KRKK İlan', value: 'KRKK_ILAN' },
			{ label: 'SGK İlan', value: 'SGK_ILAN' },
		];

		return (
			<div>
				{
					(this.state.isLoading)&&
					<div className="loader">
						<LoadingIndicator/>
					</div>
				}

				<div className="card-body mt-1">
					<Form>
						<div className="FormRenk col-sm-12">
							<span className="form-title">Evrak Bilgileri</span>
							<div className='col-sm-12 row'>
								<div className="col-sm-2">
									<label>Başlık *</label>
								</div>
								<div className="col-sm-10">
									<div className={"form-group" + this.validateClass('tTitle')}>
										<input className="form-control"
											   type="text"
											   name="title"
											   id="tTitle"
											   data-vlength="1,255"
											   onBlur={this.validateField}
											   ref="tTitle"
											   style={{  height:30}}
											   value={this.state.announcement.title}
											   onChange={(e) => this.onChangeAnnouncement(e)}/>
										{this.validateMessage('tTitle') !== "" &&
											<UncontrolledTooltip placement="right" target="tTitle" delay={0}>
												{this.validateMessage("tTitle")}
											</UncontrolledTooltip>}
									</div>
								</div>

							</div>
							{/* TEXT ROW */}

							<div className='col-sm-12 row'>
								<div className="col-sm-2">
									<label>Metin *</label>
								</div>
								<div className="col-sm-10">
									<div className={"form-group" + this.validateClass('tAdres')}>
										< BraftEditor
											value = { this.state.editorState }
											onChange = { this.handleEditorChange }
											language={'tr'}
										/>
										{this.validateMessage('tText') !== "" &&
											<UncontrolledTooltip placement="right" target="tText" delay={0}>
												{this.validateMessage("tText")}
											</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							<div className="row">
								<Label className="col-sm-2">Baş. Tarihi *</Label>
								<div className={"col-sm-10 form-group" + this.validateClass('tStartDate')}>
									<DatePicker {...tStartDate}
												className="basic-single"
												placeholder="Tarih seçiniz."
												classNamePrefix="select"
												format= "DD.MM.YYYY"
												name="startDate"
												id="tStartDate"
												ref="tStartDate"
												style={{ width: 250 , height:30}}
												inputProps={{'vdata': "required"}}
												onChange={(dateString)=>this.onChangeDate("startDate",dateString)}/>
									{this.validateMessage('tStartDate') !== "" &&
										<UncontrolledTooltip placement="right" target="tStartDate" delay={0}>
											{this.validateMessage("tStartDate")}
										</UncontrolledTooltip>}
								</div>
							</div>
							<div className="row">
								<Label className="col-sm-2">Dış İlan mı?:</Label>
								<div className={"col-sm-10 form-group" + this.validateClass('tUnemployed')}>
									<Switch checked={this.state.announcement.ilanYeri}
											disabled={this.state.fieldsDisabled}
											checkedChildren="Evet"
											unCheckedChildren="Hayır"
											style={{ width: 150 }}
											onChange={(state)=>this.onChangeIlanYeri("ilanYeri",state)} />
								</div>
							</div>
							<div className="row">
								<Label className="col-sm-2">İlan/Haber Türü:</Label>
								<div className={"col-sm-10 form-group" + this.validateClass('tUnemployed')}>
									<Select
										className="basic-single"
										disabled={this.state.fieldsDisabled}
										defaultValue={{ label: 'Nöbet Listesi', value: 'NOBETLISTESI' }}
										classNamePrefix="select"
										placeholder="Seçiniz"
										isClearable={false}
										isSearchable={false}
										name="belgeTuru"
										id="tBelgeTuru"
										ref="tBelgeTuru"
										style={{ flex: 1 }}
										inputProps={{ 'vdata': "required" }}
										options={IlanTuruOptions}
										onChange={(value) => this.onChangeIlanTuru("ilanTuru", value)}
										value={IlanTuruOptions.find(
											(option) => option.value === this.state.announcement.ilanTuru
										) || ""} />
								</div>
							</div>
							<div className="row">
								<Label className="col-sm-2">Gruplar *</Label>
								<div className={"col-sm-9 form-group" + this.validateClass('tGrup')}>
									<Select
										isDisabled={this.state.announcement.ilanYeri}
										isMulti
										className="basic-multi-select"
										classNamePrefix="select"
										placeholder="Seçiniz."
										style={{ width: 250}}
										options={this.props.userGroups}
										onChange={(e)=>this.onSelectInfoChange(e)}
										value={this.state.selectedGroups}
									/>
									{this.validateMessage('tGrup') !== "" &&
										<UncontrolledTooltip placement="right" target="tGrup" delay={0}>
											{this.validateMessage("tGrup")}
										</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					</Form>
				</div>

				{/* CARD FOOTER */}
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px',width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8"></div>
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={() => this.saveAnnouncement()}>Kaydet
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default AnnouncementForm;


// WEBPACK FOOTER //
// ./src/page/announcement/AnnouncementForm.js